// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-module_carouselWrapper__gCVHV {
    /*padding-left: 16px;*/
    /*margin-bottom: 16px;*/
}

.carousel-module_buttonStory__GqhFi {
    cursor: grab;
    box-sizing: border-box;
    padding: 12px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    color: var(--white);
    height: 120px;
    margin: 2px 8px;
    border: 0;
    border-radius: 12px;
    outline-offset: 1px;
    outline: 1px solid var(--purple_100);
}

.carousel-module_imageSource__WmSPE {
    background: var(--imageSource);
}

.carousel-module_blue_1__UafjP {
    background: var(--gradient-blue_1);
}

.carousel-module_blue_2__ij3zG {
    background: var(--gradient-blue_2);
}

.carousel-module_blue_3__j8ZZ4 {
    background: var(--gradient-blue_3);
}

.carousel-module_aubergine_1__hI2I7 {
    background: var(--gradient-aubergine_1);
}

.carousel-module_aubergine_2__Gox19 {
    background: var(--gradient-aubergine_2);
}

.carousel-module_aubergine_3__UbDeG {
    background: var(--gradient-aubergine_3);
}

.carousel-module_passionFruit_1__wzppc {
    background: var(--gradient-passionFruit_1);
}

.carousel-module_passionFruit_2__y5f0l {
    background: var(--gradient-passionFruit_2);
}

.carousel-module_passionFruit_3__elOPT {
    background: var(--gradient-passionFruit_3);
}

.carousel-module_carouselDotGroup__KFkCK {
    margin-top: 16px;
    display: none;

    @media screen and (min-width: 481px) {
        display: block;
    }

    & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
    }

}

.carousel-module_carouselDotGroup__KFkCK button {
    background-color: var(--grey_16_lc);
    padding: 0;
    cursor: pointer;
    border-radius: 50%;
    height: 8px;
    width: 8px;
}

.carousel-module_carouselDotGroup__KFkCK button:disabled {
    background-color: var(--purple_100);
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Carousel/carousel.module.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,aAAa;;IAEb;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,QAAQ;IACZ;;AAEJ;;AAEA;IACI,mCAAmC;IACnC,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,mCAAmC;IACnC,eAAe;AACnB","sourcesContent":[".carouselWrapper {\n    /*padding-left: 16px;*/\n    /*margin-bottom: 16px;*/\n}\n\n.buttonStory {\n    cursor: grab;\n    box-sizing: border-box;\n    padding: 12px;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    color: var(--white);\n    height: 120px;\n    margin: 2px 8px;\n    border: 0;\n    border-radius: 12px;\n    outline-offset: 1px;\n    outline: 1px solid var(--purple_100);\n}\n\n.imageSource {\n    background: var(--imageSource);\n}\n\n.blue_1 {\n    background: var(--gradient-blue_1);\n}\n\n.blue_2 {\n    background: var(--gradient-blue_2);\n}\n\n.blue_3 {\n    background: var(--gradient-blue_3);\n}\n\n.aubergine_1 {\n    background: var(--gradient-aubergine_1);\n}\n\n.aubergine_2 {\n    background: var(--gradient-aubergine_2);\n}\n\n.aubergine_3 {\n    background: var(--gradient-aubergine_3);\n}\n\n.passionFruit_1 {\n    background: var(--gradient-passionFruit_1);\n}\n\n.passionFruit_2 {\n    background: var(--gradient-passionFruit_2);\n}\n\n.passionFruit_3 {\n    background: var(--gradient-passionFruit_3);\n}\n\n.carouselDotGroup {\n    margin-top: 16px;\n    display: none;\n\n    @media screen and (min-width: 481px) {\n        display: block;\n    }\n\n    & > div {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 8px;\n    }\n\n}\n\n.carouselDotGroup button {\n    background-color: var(--grey_16_lc);\n    padding: 0;\n    cursor: pointer;\n    border-radius: 50%;\n    height: 8px;\n    width: 8px;\n}\n\n.carouselDotGroup button:disabled {\n    background-color: var(--purple_100);\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carouselWrapper": `carousel-module_carouselWrapper__gCVHV`,
	"buttonStory": `carousel-module_buttonStory__GqhFi`,
	"imageSource": `carousel-module_imageSource__WmSPE`,
	"blue_1": `carousel-module_blue_1__UafjP`,
	"blue_2": `carousel-module_blue_2__ij3zG`,
	"blue_3": `carousel-module_blue_3__j8ZZ4`,
	"aubergine_1": `carousel-module_aubergine_1__hI2I7`,
	"aubergine_2": `carousel-module_aubergine_2__Gox19`,
	"aubergine_3": `carousel-module_aubergine_3__UbDeG`,
	"passionFruit_1": `carousel-module_passionFruit_1__wzppc`,
	"passionFruit_2": `carousel-module_passionFruit_2__y5f0l`,
	"passionFruit_3": `carousel-module_passionFruit_3__elOPT`,
	"carouselDotGroup": `carousel-module_carouselDotGroup__KFkCK`
};
export default ___CSS_LOADER_EXPORT___;
